// extracted by mini-css-extract-plugin
export default {"layout":"layout___zqq5F","frame":"frame___OT4jj","content":"content___QMYVR"};